import React from 'react';
import generatePicker from 'antd/es/date-picker/generatePicker';
import type { PickerProps } from 'antd/es/date-picker/generatePicker';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MomentPicker = generatePicker<Moment>(momentGenerateConfig);

type TimeAdjustedDatePickerProps = Omit<PickerProps<Moment>, 'onChange'> & {
  onChange?: (date: Moment, dateString: string) => void;
};

const TimeAdjustedDatePicker: React.FC<TimeAdjustedDatePickerProps> = (props) => {
  const { onChange, ...rest } = props;

  const handleChange = (date: Moment, dateString: string) => {
    const adjustedDate = date?.clone().hour(12).minute(0).second(0);
    onChange?.(adjustedDate, dateString);
  };

  return (
    <MomentPicker
      {...rest}
      // @ts-ignore: Type conflict with range picker
      onChange={handleChange}
    />
  );
};

export { TimeAdjustedDatePicker };
